import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { useWishlist } from "@temp/@sdk/react";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
export function WishlistCount() {
  var _useWishlist = useWishlist(),
      wishlist = _useWishlist.wishlist;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      animate = _useState2[0],
      setAnimate = _useState2[1];

  var firstUpdate = useRef(true);
  useEffect(function () {
    function triggerAnimate() {
      setAnimate(true);
      var timeout = setTimeout(function () {
        setAnimate(false);
      }, 2000);
      return function () {
        clearTimeout(timeout);
      };
    }

    if (wishlist === null) {
      return;
    }

    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    return triggerAnimate();
  }, [wishlist === null || wishlist === void 0 ? void 0 : wishlist.length]);

  if (!(wishlist === null || wishlist === void 0 ? void 0 : wishlist.length)) {
    return React.createElement(React.Fragment, null);
  }

  return React.createElement("div", {
    className: classNames("wishlist-count", {
      "wishlist-count--animate": animate
    })
  }, wishlist === null || wishlist === void 0 ? void 0 : wishlist.length);
}